






















import { Component, Prop, Vue } from 'vue-property-decorator';
import PrineButton from '@/components/prine/PrineButton.vue';

import type { LessonsFilter } from '@/helpers/types/LessonsFilter';
import { Tag } from '@/models/tag';
import type { CompanySetting } from '@/models/companySetting';
import { Getter } from 'vuex-class';

@Component({
    name: 'UpdateFilter',
    components: { PrineButton },
})
export default class UpdateFilter extends Vue {
    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Prop() private filters: LessonsFilter;
    @Prop() private tags: Tag[];

    private updateFilters() {
        this.$emit('update:filters', this.filters);
    }
}
